export default __webpack_public_path__ + "static/info-pane-325b0ad8bacb65929c423672fdcd5a47.png";